export default __webpack_public_path__ + "static/media/bprJatimLogo.f8157c9b.png";